// Formato de fecha para Centro América (12 horas con AM/PM)
// Usa la zona horaria local del navegador del usuario
export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  // Asegurar que la fecha se interprete como UTC agregando 'Z' si no tiene zona horaria
  let utcDateString = dateString;
  if (!dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('-', 10)) {
    utcDateString = dateString + 'Z';
  }
  const date = new Date(utcDateString);
  return date.toLocaleString('es-GT', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};

export const formatDateShort = (dateString) => {
  if (!dateString) return 'N/A';
  let utcDateString = dateString;
  if (!dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('-', 10)) {
    utcDateString = dateString + 'Z';
  }
  const date = new Date(utcDateString);
  return date.toLocaleString('es-GT', { 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric'
  });
};

export const formatTime = (dateString) => {
  if (!dateString) return 'N/A';
  let utcDateString = dateString;
  if (!dateString.endsWith('Z') && !dateString.includes('+') && !dateString.includes('-', 10)) {
    utcDateString = dateString + 'Z';
  }
  const date = new Date(utcDateString);
  return date.toLocaleString('es-GT', { 
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
};
